import React from "react";
import { TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import appStyles from "../../../../appStyles";

export default function ListIcon(props) {
  const width = props.width || 20;
  const height = props.height || 20;
  const color = props.fillColor || "#FFF";

  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={[appStyles.iconContainer, props.style]} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.80523 4.81814C3.80523 5.6389 3.13988 6.30426 2.31912 6.30426C1.49836 6.30426 0.833008 5.6389 0.833008 4.81814C0.833008 3.99739 1.49836 3.33203 2.31912 3.33203C3.13988 3.33203 3.80523 3.99739 3.80523 4.81814ZM3.80523 9.93006C3.80523 10.7508 3.13988 11.4162 2.31912 11.4162C1.49836 11.4162 0.833008 10.7508 0.833008 9.93006C0.833008 9.1093 1.49836 8.44394 2.31912 8.44394C3.13988 8.44394 3.80523 9.1093 3.80523 9.93006ZM2.31912 16.5267C3.13988 16.5267 3.80523 15.8614 3.80523 15.0406C3.80523 14.2198 3.13988 13.5545 2.31912 13.5545C1.49836 13.5545 0.833008 14.2198 0.833008 15.0406C0.833008 15.8614 1.49836 16.5267 2.31912 16.5267ZM7.91611 3.58223C7.22576 3.58223 6.66611 4.14187 6.66611 4.83223C6.66611 5.52258 7.22576 6.08223 7.91611 6.08223H17.9161C18.6065 6.08223 19.1661 5.52258 19.1661 4.83223C19.1661 4.14187 18.6065 3.58223 17.9161 3.58223H7.91611ZM6.66611 9.99883C6.66611 9.30847 7.22576 8.74883 7.91611 8.74883H17.9161C18.6065 8.74883 19.1661 9.30847 19.1661 9.99883C19.1661 10.6892 18.6065 11.2488 17.9161 11.2488H7.91611C7.22576 11.2488 6.66611 10.6892 6.66611 9.99883ZM7.91611 13.7486C7.22576 13.7486 6.66611 14.3083 6.66611 14.9986C6.66611 15.689 7.22576 16.2486 7.91611 16.2486H17.9161C18.6065 16.2486 19.1661 15.689 19.1661 14.9986C19.1661 14.3083 18.6065 13.7486 17.9161 13.7486H7.91611Z"
          fill={color}
        />
      </Svg>
    </TAG>
  );
}
